import { createTheme } from '@mui/material/styles';

const themeDark = createTheme({
  palette: {
    // primary: { main: '#238636' },
    // secondary: { main: '#b62324' },
    mode: 'dark',
    background: { default: '#0d1117' },
    text: {
      primary: '#c9d1d9',
    },
  },
  typography: {
    fontFamily: ['CircularStd', 'sans-serif'].join(','),
    button: {
      textTransform: 'none',
    },
  },
});

const themeLight = createTheme({
  palette: {
    // primary: { main: '#238636' },
    // secondary: { main: '#b62324' },
    mode: 'light',
    background: { default: '#f6f9fc' },
    text: {
      primary: '#111',
    },
  },
  typography: {
    fontFamily: ['CircularStd', 'sans-serif'].join(','),
    button: {
      textTransform: 'none',
    },
    fontSize: 14,
  },
});

export { themeDark, themeLight };
